"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var classes_1 = require("../utils/classes");
var iconSVG_1 = require("./iconSVG");
// TODO: make these configurable for custom types...
// Or allow custom viewBox
var SIZE_STANDARD = 16;
var SIZE_LARGE = 20;
var renderSvgPaths = function (pathsSize, iconName) {
    var svgPathsRecord = pathsSize === SIZE_STANDARD ? iconSVG_1.IconSvgPaths16 : iconSVG_1.IconSvgPaths20;
    var pathStrings = svgPathsRecord[iconName];
    if (pathStrings == null) {
        return null;
    }
    return pathStrings.map(function (d, i) { return react_1.default.createElement("path", { key: i, d: d, fillRule: "evenodd" }); });
};
var Icon = function (_a) {
    var children = _a.children, _b = _a.size, size = _b === void 0 ? 'standard' : _b, icon = _a.icon, color = _a.color, className = _a.className;
    var sizePixels = size === 'standard' ? 16 : size === 'large' ? 20 : size;
    var pixelGridSize = sizePixels >= SIZE_LARGE ? SIZE_LARGE : SIZE_STANDARD;
    var viewBox = "0 0 " + pixelGridSize + " " + pixelGridSize;
    // style = { ...style, fill: theme.getIconColor(color) };
    // TODO: set color, make sure to white list theme in the 'remover'...
    return (react_1.default.createElement("svg", { className: classnames_1.default(color && "text-" + color, 'fill-current', classes_1.addClassName('icon'), className), width: sizePixels, height: sizePixels, viewBox: viewBox }, renderSvgPaths(pixelGridSize, icon)));
};
exports.default = Icon;
//# sourceMappingURL=icons.js.map